import React from 'react';
import styled from 'styled-components';
import ExecutedActivities from './ExecutedActivities';
import Project from './Project';

const BasicInfo = ({
  activities,
  onAddActivity,
  onChange,
  onChecked,
  onDelete,
  onProject,
  projectSlug,
  year,
}) => {
  return (
    <Container>
      <Project data={projectSlug} onProject={onProject} year={year} />
      <ExecutedActivities
        data={activities}
        onAddActivity={onAddActivity}
        onChange={onChange}
        onChecked={onChecked}
        onDelete={onDelete}
      />
    </Container>
  );
};

const Container = styled.section`
  width: 90%;
`;

export default BasicInfo;
